import { useContext } from 'react';
import { AppContext } from '@ctsu/loader';

const Lovs = new Map();
const key = 'LOV_INSTITUTION_ROSTER';

export default function StudyTypeLovs() {
  const context = useContext(AppContext);
  const { application } = context;

  const { appConfig: { LOV_INSTITUTION_ROSTER } = {} } = application || [];
  Lovs.set(key, LOV_INSTITUTION_ROSTER);
  return null;
}
export function studyTypeLovContext() {
  const data = Lovs.get(key);
  try {
    return JSON.parse(data);
  } catch (error) {
    return error;
  }
}
